import React from 'react';
import PropTypes from 'prop-types';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import styles from './project-role.module.css';
import RevealSlideDown from '../../animations/reveal-slide-down';

const RoleList = props => {
  const { roles, animation } = props;
  return (
    roles && (
      <ul className={styles.list} style={animation}>
        {roles.map((item, index) => {
          return (
            <li className={styles.item} key={index}>
              {item.role}
            </li>
          );
        })}
      </ul>
    )
  );
};

const ProjectRole = props => {
  const { isInView } = props;
  const animationConfig = {
    delay: 0,
    duration: 900,
    easing: easings.easeCubicOut,
  };
  return (
    <Spring
      from={{ opacity: 0, width: '0%' }}
      to={{
        opacity: isInView ? 1 : 0,
        width: isInView ? '100%' : '0%',
      }}
      config={animationConfig}
    >
      {animation => (
        <div>
          <h4 className={styles.title} style={{ opacity: animation.opacity }}>
            JK's Role
          </h4>
          <span
            className={styles.dash}
            style={{
              width: animation.width,
            }}
          />
          <RevealSlideDown isInView={isInView}>
            <RoleList {...props} />
          </RevealSlideDown>
        </div>
      )}
    </Spring>
  );
};

ProjectRole.propTypes = {
  roles: PropTypes.array,
  animation: PropTypes.object,
};

export default ProjectRole;



// WEBPACK FOOTER //
// ./src/components/project/project-role/index.js